<div class="add-payment">
  <!-- DIALOG HEADER -->
  <div class="ui-g-12 p-zero dialog-header">
    <div class="send-dialog-heading">{{ title }}</div>

    <i class="fal fa-times fa-sm dialog-close" (click)="close()"></i>
  </div>

  <!-- DIALOG BODY -->
  <div class="dialog-body ui-g-12 p-zero">
    <!-- Start Left panel -->
    <div class="ui-g-8 p-zero left-box">
      <!-- Order details -->
      <div class="ui-g-12 p-0 mb-8px">
        <div class="customer not-allowed">
          <label class="font-600 font-12 mb-4px">Order*</label>
          <div class="input-box">
            <div class="font-12 title-icon">
              <div class="icon-wrapper">
                <i class="fal fa-file-alt file-icon"></i>
              </div>
              <div class="font-light capitalize font-bold code-title">{{ order?.code }} - {{ order?.title ||
                defaultOrderTitle }}</div>
              <div class="font-light font-capitalize text-right workflow-status">
                {{ order?.workFlowStatus }}
              </div>
            </div>
            <div class="font-10">
              <div class="font-light customer-email-phone">
                {{ customerName }}
                <span *ngIf="customer?.phone"> - ({{ customer?.phone | mask : '(000) 000-0000' }})</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Payment Type -->
      <div class="ui-g-12 p-0 mb-5px">
        <div class="ui-g-12 p-zero">
          <p class="font-12 font-600 mb-4px float-left">Payment types*</p>
        </div>
        <div class="ui-g-12 p-zero payment-not-allowed">
          <div class="d-flex mb-2">
            <div *ngFor="let paymentType of paymentTypes"
              class="payment-method-card text-center pointer mr-2 disabled not-allowed"
              [ngClass]="{ 'active-card': paymentType.value === activePaymentType?.value }">
              <div class="payment-method-inner">
                <i class="font-24 {{ paymentType.icon }}"></i>
                <p class="font-12 font-bold mb-0">{{ paymentType.label }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- payment source -->
      <div class="ui-g-12 p-0 mb-5px" hidden>
        <div class="ui-g-12 p-zero">
          <p class="font-12 font-600 mb-4px float-left">Payment source*</p>
        </div>
        <div class="ui-g-6 p-0">
          <button type="submit" class="btn btn-white pointer btn-submit w-100"
            [ngClass]="{ 'btn-payment-source': isSourcePaymentOnline }"
            (click)="selectPaymentSource('isSourcePaymentOnline')">
            Online Card Entry
          </button>
        </div>
        <div class="ui-g-6 p-0 pl-1">
          <button type="submit" class="btn btn-white pointer btn-submit mr-1 w-100"
            [ngClass]="{ 'btn-payment-source': isSourcePaymentCardSwipe }"
            (click)="selectPaymentSource('isSourcePaymentCardSwipe')">
            Card Swipe
          </button>
        </div>
      </div>

      <div *ngIf="!isDebitTransection()  || afterRefundOnline" class="ui-g-12 p-0 mb-3">
        <label class="font-12 font-600 mb-4px"><span>Payment method*</span></label>
        <app-dropdown placeholder="Select" theme="border" position="top" field="name" scrollHeight="200px"
          styleClassSelectedView="payment-method-dropdown" [fontSize]="12" [disabled]="true"
          [setPositionDynamically]="false" [options]="paymentMethods" [isDropdownIconVisible]="true"
          [value]="selectedPaymentMethod">
        </app-dropdown>
      </div>

      <!-- Amount & Date -->
      <div class="ui-g-12 p-0 mb-3">
        <div class="ui-g-4 p-0 pr-2">
          <label class="font-12 font-600 mb-4px">Date</label>
          <div
            [ngClass]="{ 'disabled-with-default': isPaymentArchived || voidPayment || (!changePaymentData && isPaymentDataPrivilgesEnabled) }">
            <div class="calendar-input flex-between-center payment-date pointer">
              <p-calendar id="payment-date" placeholder="Time" styleClass="payment-pointer"
                [(ngModel)]="refund.refundDate"
                [disabled]="isPaymentArchived || voidPayment || (!changePaymentData && isPaymentDataPrivilgesEnabled)"
                [readonlyInput]="true" [minDate]="payment.paymentDate" [maxDate]="maxDateRange" dateFormat="M d, yy"
                appendTo="body" #paymentDateTimeEl>
              </p-calendar>
              <i class="fal fa-calendar" [ngClass]="{ 'd-none': isPaymentArchived || voidPayment }"
                (click)="(isPaymentDataPrivilgesEnabled && changePaymentData &&
              paymentDateTimeEl.showOverlay()) || (!isPaymentDataPrivilgesEnabled && paymentDateTimeEl.showOverlay())"></i>
            </div>
          </div>
        </div>

        <div class="ui-g-4 p-0 pr-2">
          <label class="font-12 font-600 mb-4px">Time*</label>
          <div [ngClass]="{ 'disabled-with-default': isPaymentArchived || voidPayment }">
            <kendo-timepicker [(value)]="maxDateRange"
              [disabled]="isPaymentArchived || voidPayment || (!changePaymentData && isPaymentDataPrivilgesEnabled)"
              [(value)]="refund.refundTime" [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }">
            </kendo-timepicker>
          </div>
        </div>

        <div class="ui-g-4 p-0">
          <label class="font-12 font-600 mb-4px">{{refundTitle}} amount*</label>
          <app-input *ngIf="!voidPayment" id="payment-amount" placeholder="$0.00" theme="border" [fontSize]="13"
            [selectTextOnFocus]="true" [hasHoverBorderBottom]="false"
            [allowDecimal]="isRefundAmountFieldFocused ? true : false" [autoFocus]="false"
            [disabled]="isPaymentArchived || afterRefundOnline" [hasHoverEffect]="false"
            [value]="isRefundAmountFieldFocused ? refund.amount : (refund.amount | currency : usd)"
            [isInvalid]="errors.refundAmountError" [errorMessage]="errors.refundAmountError"
            (appChange)="handleRefundAmountChange($event)" (appFocus)="handleRefundAmountFocus()"
            (appBlur)="isRefundAmountFieldFocused = false; validateForm()">
          </app-input>
          <!-- voidPayment -->
          <app-input *ngIf="voidPayment" id="payment-amount" placeholder="$0.00" theme="border" [fontSize]="13"
            [selectTextOnFocus]="true" [hasHoverBorderBottom]="false"
            [allowDecimal]="isRefundAmountFieldFocused ? true : false" [autoFocus]="false" [disabled]="voidPayment"
            [hasHoverEffect]="false"
            [value]="isRefundAmountFieldFocused ? refund.amount : (refund.amount | currency : usd)">
          </app-input>
        </div>
      </div>
      <!-- payment if online and add confiration and last 4 digits -->
      <div *ngIf="afterRefundOnline" class="ui-g-12 p-0 mb-10px">
        <div class="ui-g-6 p-0 pr-2">
          <label class="font-12 font-600 mb-4px">Last 4 digits*</label>
          <app-input type="text" mask="9999" theme="border" placeholder="" class="font-13" id="payment-card-last-4"
            [hasHoverBorderBottom]="false" [disabled]="true" [hasHoverEffect]="false"
            (appChange)="handleChange($event, 'card4Digits')" [value]="refund.card4Digits">
          </app-input>
        </div>
        <div class="ui-g-6 p-0">
          <label class="font-12 font-600 mb-4px">Confirmation no.*</label>
          <app-input id="payment-card-conf-no" type="text" theme="border" placeholder="" mask="0*"
            [patterns]="confirmCardPattern" class="font-13" [hasHoverBorderBottom]="false" [disabled]="true"
            [hasHoverEffect]="false" (appChange)="handleChange($event, 'cardConfNo')" [value]="refund.cardConfNo">
          </app-input>
        </div>
      </div>

      <!-- terminals -->
      <div *ngIf="isSourcePaymentCardSwipe && isDebitTransection()" [hidden]="afterRefundOnline" class="ui-g-12 p-0">
        <label class="font-12 font-600 mb-4px">
          <span>Select Terminal*</span>
        </label>

        <app-dropdown placeholder="Select Terminal" theme="border" position="top" field="name" scrollHeight="200px"
          styleClassSelectedView="payment-method-dropdown" [fontSize]="12" [setPositionDynamically]="false"
          [options]="terminalList" [isDropdownIconVisible]="true" [hasCustomItemTemplate]="true"
          [value]="selectedTerminal" (appSelect)="onTerminalSelect($event)">
          <ng-template let-item appTemplate="item">
            <div class="ui-g single-terminal">
              <div class="ui-g-12 p-0 flex-start-start">
                <div class="w-100">
                  <p class="font-14 font-secondary-900 font-600 m-0">{{ item?.name }}</p>
                  <i class="font-12" *ngIf="!item.isTransactionPending">Available</i>
                  <i class="font-12" *ngIf="item.isTransactionPending">Unavailable
                    <span class="pl-4">#{{ item?.pendingRo }}</span>
                  </i>
                </div>
              </div>
            </div>
          </ng-template>
        </app-dropdown>
      </div>
      <!-- pay online and card buttons -->
      <div *ngIf="isSourcePaymentOnline && isDebitTransection()" class="ui-g-12 p-zero mb-10px">
        <label class="font-12 font-600 mb-4px">Pay online</label>
        <div class="form-group font-14 mb-20 notes">
          <button [disabled]="!refund.amount" id="OnlineCardEntryButton" (click)="openScreen()"
            class="btn btn-primary pointer btn-submit mr-1 w-100">
            Refund Online - Card Entry
            <i *ngIf="opening" class="fal fa-spinner rotate"></i>
          </button>
        </div>
      </div>
      <!-- featurefeatureIsPayRixEnableEnable -->
      <div [hidden]="afterRefundOnline" *ngIf="isSourcePaymentCardSwipe && isDebitTransection()"
        class="ui-g-12 p-zero mb-10px">
        <label class="font-12 font-600 mb-4px">Refund online</label>
        <div class="form-group font-14 mb-20 notes">
          <button [disabled]="!refund.amount && selectedTerminal" id="SwipeCardEntryButton" (click)="openCardSwipe()"
            class="btn btn-submit mr-1 w-100"
            [ngClass]="[refund.amount && selectedTerminal ? 'btn-primary pointer' : 'btn-white']">
            Refund Online - Card Swipe
            <i *ngIf="opening" class="fal fa-spinner rotate"></i>
          </button>
        </div>
      </div>

      <!-- Notes -->
      <div class="ui-g-12 p-zero" [ngClass]="errors.refundAmountError.length > 26 ? 'mt-5' : 'mt-0'">
        <label class="font-12 font-600 mb-4px">Notes</label>
        <div class="form-group custom-text-area font-14 mb-20 notes">
          <textarea id="payment-notes" name="notes" [disabled]="isPaymentArchived" placeholder="Notes" rows="4"
            [(ngModel)]="refund.notes"></textarea>
        </div>
      </div>
    </div>

    <!-- Start Right Panel -->
    <div class="ui-g-4 p-zero right-box">
      <!-- Gross Payment -->
      <div class="label-row mb-1 border-bottom">
        <div class="label-heading">Gross payment</div>
        <div class="label-value">
          {{ payment.amount || 0 | currency : usd }}
        </div>
      </div>

      <!-- Refund to date -->
      <div class="label-row mb-1 mt-2">
        <div class="label-heading">{{refundTitle}} to date</div>
        <div class="label-value">({{ refundToDate || 0 | currency : usd }})</div>
      </div>

      <!-- Refund amount -->
      <div class="label-row mb-1 border-bottom">
        <div class="label-heading">{{refundTitle}} amount</div>
        <div class="label-value">({{ isRefundAmountFieldFocused && refund.amount + '' == '.' ? (0 | currency : usd) :
          (refund.amount || 0 | currency : usd) }})</div>
      </div>

      <!-- Post refund amount -->
      <div class="label-row mb-2">
        <div class="label-heading">Post amount</div>
        <div class="label-value" *ngIf="postRefundAmount >= 0">
          {{ postRefundAmount || 0 | currency : usd }}
        </div>
        <div class="label-value" *ngIf="postRefundAmount < 0">({{ (postRefundAmount || 0) * -1 | currency : usd }})
        </div>
      </div>

      <!--  Payment History -->
      <div class="ui-g-12 p-0 mt-40 payment-history" *ngIf="payment.history.length > 0">
        <div class="label-row mb-1 border-bottom">
          <label class="label-heading font-13 font-600">Payment history</label>
        </div>
        <div class="ui-g-12 p-0 mt-1 payment-history" *ngFor="let history of payment.history" tooltipPosition="left"
          tooltipStyleClass="ticket-tooltip modifier payment-hostory-size completed" [escape]="false"
          [pTooltip]="history.tooltip">
          <div class="history-row font-11">
            <span class="history-heading">{{ history.date | date : 'MMM d, yyyy h:mm a' }}</span>
            <span class="history-heading float-right">
              {{ history?.amount | currency : usd }}
            </span>
          </div>

          <div class="history-payment-type font-gray-55">
            <span *ngIf="history.paymentType === 'cash'"> Cash </span>

            <span *ngIf="history.paymentType === 'cheque'"> {{ dataService.checkTxt }} {{ history.checkNo }} </span>

            <span *ngIf="history.paymentType === 'card' && (history.isOnline || history.isCardSwipe)">
              {{ history?.isOnline ? 'Card '+ history?.cardSource : history?.isCardSwipe ? 'Card ' + history?.cardSource
              : 'Card (Manual)' }}
            </span>

            <span [hidden]="history.isOnline || history.isCardSwipe" *ngIf="history.paymentType === 'card'"> Card {{
              history.cardType }} {{ history.card4Digits }} </span>

            <span *ngIf="history.type === 'Refund'"> {{history.title}} </span>
            <span *ngIf="history?.madeBy">- {{ history?.madeBy }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- End Right Panel -->
  </div>

  <!-- DIALOG FOOTER-->
  <div class="ui-g-12 p-zero dialog-footer">
    <div class="ui-g-4 p-zero text-right float-right payment-add-footer">
      <button id="payment-btn-cancel" class="btn btn-white btn-border pointer btn-submit mr-1"
        (click)="close()">Cancel</button>
      <button id="payment-btn-save" class="btn btn-primary btn-submit" [disabled]="isSubmitting || isPaymentArchived"
        (click)="onSubmit()">
        <span [ngClass]="{ 'pr-2': isSubmitting }">Save</span>
        <i *ngIf="isSubmitting" class="fal fa-spinner rotate"></i>
      </button>
    </div>
  </div>
</div>
